import request from '@/utlis/request'

/**
 *
 * @returns 多图上传
 */
export function multipleImageUpload(data) {
    return request({
        url: '/file/multipleImageUpload',
        method: 'POST',
        data
    })
}


export function uploadBase64(data) {
    return request({
        url: '/file/uploadBase64',
        method: 'POST',
        data
    })
}


export function downLoadImage(data) {
    return request({
        url: '/file/downLoadImage',
        method: 'POST',
        params: data
    })
}

